<template>
  <BigContainer>
    <article class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
      <SurfaceWell>
      <SectionCard>
      <header class="mb-10 text-center">
        <NuxtLink
          :href="`/blog/${article.category.slug}`"
          class="inline-block text-amber-600 dark:text-amber-400 text-xs font-semibold uppercase tracking-widest hover:underline">
          {{ article.category.name }}
        </NuxtLink>
        <h1 class="mt-4 font-serif font-semibold text-4xl sm:text-5xl leading-tight tracking-tight text-gray-900 dark:text-gray-100">
          {{ article.title }}
        </h1>
        <div class="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm text-gray-500 dark:text-gray-400">
          <span v-if="article.user">By {{ article.user.name }}</span>
          <span v-if="article.user" class="text-gray-300 dark:text-gray-600">&bull;</span>
          <time :datetime="String(article.created_at)">{{ formatDate(article.created_at, false) }}</time>
          <span class="text-gray-300 dark:text-gray-600">&bull;</span>
          <span>{{ readingTime }} min read</span>
        </div>
      </header>

      <div class="prose prose-lg dark:prose-invert mx-auto">
        <Markdown :content="article.body"/>
      </div>
      </SectionCard>
      </SurfaceWell>
    </article>
  </BigContainer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { formatDate } from '~/utils/date';
import { blogReadingTime } from '~/utils/blog';

const props = defineProps<{
  article: BlogArticle;
  full?: boolean;
}>();

const readingTime = computed(() => blogReadingTime(props.article.body));
</script>
